import { render } from "./termsUse.vue?vue&type=template&id=b91b866a&scoped=true"
import script from "./termsUse.vue?vue&type=script&lang=js"
export * from "./termsUse.vue?vue&type=script&lang=js"

import "./termsUse.vue?vue&type=style&index=0&id=b91b866a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b91b866a"]])

export default __exports__